import { BaseService } from '@/core/base-service';
import axios from 'axios';

export default class ProjectTemplateService extends BaseService<any> {
	public constructor() {
		super('services/servicepze/api/project-template');
	}

	public getOptions(): Promise<any> {
		return axios.get(this.endpointName + '/combobox');
	}
}
